import React from 'react'
import * as styles from './Button.m.css'

export enum ButtonColors {
  Blue = 'blue',
  Yellow = 'yellow',
  Red = 'red',
  Green = 'green',
  Grey = 'grey',
  White = 'white',
}

type Props = {
  children?: React.ReactNode
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  color?: ButtonColors
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
}

const noopHandler: React.MouseEventHandler<HTMLButtonElement> = () => {}

export function getButton(injectedClasses: string[] = []) {
  const Button: React.FC<Props> = (props: Props): React.ReactElement => {
    const color = props.color || ButtonColors.Blue
    const handler = props.disabled ? noopHandler : props.onClick
    const disabledClass = props.disabled ? styles.disabled : ''
    const type = props.type || 'button'

    const colorClass = styles[color]

    return (
      <button
        className={`${styles.button} ${colorClass} ${disabledClass} ${injectedClasses.join(' ')}`}
        onClick={handler}
        type={type}
      >
        {props.children}
      </button>
    )
  }

  return Button
}
